module.exports = __webpack_public_path__ + "static/media/electricity_2.3c41436f.svg";